import type {PricedItem, PricingNodegraph} from "#pricing/types/pricing-types"
import {PriceContainer} from "#pricing/nodes/price-container"
import {PricedItemNode} from "#pricing/nodes/priced-item-node"
import {VariantConditionNode} from "#pricing/nodes/variant-condition-node"
import {PricingNode, registerPricingGraphNode} from "#pricing/pricing-node"
import {PricingListNode, pricingListDefinition} from "#pricing/pricing-list-node"
import {z} from "zod/v4-mini"

const priceListDefinition = pricingListDefinition<PricingNodegraph>("PriceList", PricingNode, z.array(z.custom<PricedItem>(() => true)))

/**This models the subprices of a node and should not show in the UI. The reason for this class is that nodegraphs nested into a parameter, e.g. an array of nodegraphs directly inside the parameters of a price node is not allowed by design of the graph system. */
@registerPricingGraphNode
export class PriceList extends PricingListNode<PricingNodegraph> {
    public override get definition() {
        return priceListDefinition
    }

    mutuallyExclusive(): boolean {
        //TODO: This code assumes "And" conditions, must be adapted to VariantCondition and container taking prices
        const conditions: string[][] = []
        for (const node of this.parameters.list) {
            if (node instanceof PriceContainer) continue
            if (!(node instanceof PricedItemNode)) throw new Error(`Subprice is not a priced item, but ${node.constructor.name}`)

            // if (!node.parameters.conditionalPrice && curConditions.length !== 0) throw new Error("Unconditional node with conditions found")
            // if (!node.parameters.conditionalPrice || (node.parameters.conditionalPrice && curConditions.length !== 0)) conditions.push(node.getVariantIds())
            const condition = node.parameters.condition
            if (condition instanceof VariantConditionNode && condition.parameters.condition.variantOperator === "AND" && condition.getVariantIds().length > 0)
                conditions.push(condition.getVariantIds())
        }

        conditions.sort((a, b) => a.length - b.length)

        for (let i = 0; i < conditions.length; i++) {
            for (let j = i + 1; j < conditions.length; j++) {
                const isSubset = conditions[i].every((condition) => conditions[j].includes(condition))
                if (isSubset) {
                    return false
                }
            }
        }

        return true
    }
}
